// store/modalStore.ts
import { create } from 'zustand';

interface MultiFormStore<T = Record<string, unknown>> {
  formData: T;
  setFormData: (data: T) => void;
  clearForm: () => void;
}

export const useMultiFormStore = create<MultiFormStore>((set) => ({
  formData: {},
  setFormData: (data) =>
    set((state) => ({ formData: { ...state.formData, ...data } })),
  clearForm: () => set({ formData: {} }),
}));
